(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("EsriMap", [], factory);
	else if(typeof exports === 'object')
		exports["EsriMap"] = factory();
	else
		root["EsriMap"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(25)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(32)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(34),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(42)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(44),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(50)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(63),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map_module_map_esrimap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map_module_map_esrimap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__map_module_map_esrimap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__map_module_maptool_legend__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__map_module_maptool_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__map_module_maptool_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__map_module_maptool_mapType__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__map_module_maptool_mapType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__map_module_maptool_mapType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__map_module_maptool_overviewMap__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__map_module_maptool_overviewMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__map_module_maptool_overviewMap__);











var components = [__WEBPACK_IMPORTED_MODULE_0__map_module_map_esrimap___default.a, __WEBPACK_IMPORTED_MODULE_1__map_module_maptool_legend___default.a, __WEBPACK_IMPORTED_MODULE_3__map_module_maptool_mapType___default.a, __WEBPACK_IMPORTED_MODULE_4__map_module_maptool_overviewMap___default.a, __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["a" /* FullExtent */], __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["b" /* FullScreen */], __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["d" /* ISearchBoard */], __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["c" /* ISearch */], __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["f" /* LocationBoard */], __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["e" /* Location */], __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["g" /* Measurement */], __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["h" /* MeasurementBoard */], __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["i" /* RenderClear */], __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["k" /* SearchBoard */], __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["j" /* Search */], __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["l" /* ZoomIn */], __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["m" /* ZoomOut */]];
var install = function install(Vue) {
  components.map(function (component) {
    Vue.component(component.name, component);
  });
};

/* harmony default export */ __webpack_exports__["default"] = ({
  EsriMap: __WEBPACK_IMPORTED_MODULE_0__map_module_map_esrimap___default.a,
  Legend: __WEBPACK_IMPORTED_MODULE_1__map_module_maptool_legend___default.a,
  MapType: __WEBPACK_IMPORTED_MODULE_3__map_module_maptool_mapType___default.a,
  OverViewMap: __WEBPACK_IMPORTED_MODULE_4__map_module_maptool_overviewMap___default.a,
  FullExtent: __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["a" /* FullExtent */],
  FullScreen: __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["b" /* FullScreen */],
  ISearchBoard: __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["d" /* ISearchBoard */],
  ISearch: __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["c" /* ISearch */],
  LocationBoard: __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["f" /* LocationBoard */],
  Location: __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["e" /* Location */],
  Measurement: __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["g" /* Measurement */],
  MeasurementBoard: __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["h" /* MeasurementBoard */],
  RenderClear: __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["i" /* RenderClear */],
  SearchBoard: __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["k" /* SearchBoard */],
  Search: __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["j" /* Search */],
  ZoomIn: __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["l" /* ZoomIn */],
  ZoomOut: __WEBPACK_IMPORTED_MODULE_2__map_module_maptool_toolbar__["m" /* ZoomOut */],
  install: install
});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(7)
__webpack_require__(8)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(11),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_esri_loader__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_esri_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_esri_loader__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EsriMap',
  data: function data() {
    return {
      esriLoader: __WEBPACK_IMPORTED_MODULE_0_esri_loader__,
      map: null,
      isloaded: false,
      curVmName: '',
      toolObject: {},
      mapClickEvent: null
    };
  },

  props: {
    elId: {
      type: String,
      default: 'page-map',
      required: true
    },
    isAddBaseMap: {
      type: Boolean,
      default: true
    },
    extention: {
      type: Object
    },
    proxyUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    mapToolConfig: function mapToolConfig() {
      return this.mapConfig;
    },
    configData: function configData() {
      return {
        map: this.map,
        esriLoader: this.esriLoader
      };
    }
  },
  created: function created() {
    var _self = this;
    this.$events.$on('barItemBoardInited', function (name, comp, vm, position) {
      _self.$options.components[name] = comp;
      _self.$set(_self.toolObject, name, vm);
      _self.$set(_self.toolObject, name + 'position', position);
    });
  },
  mounted: function mounted() {
    var _this = this;

    this.loadEsriAPI();
    var _self = this;
    this.$events.$on('barItemClick', function (barConfig) {
      if (barConfig.vmName === 'ISearch') {
        if (!_this.mapClickEvent) {
          _this.toolObject['ISearch'].active = true;

          _self.curVmName = '';
          _this.mapClickEvent = _this.activeMapClick();
        } else {
          _this.toolObject['ISearch'].active = false;
          _this.mapClickEvent.remove();
          _this.mapClickEvent = null;
        }
        return;
      }
      if (!_self.curVmName || _self.curVmName === '') {
        _self.curVmName = barConfig.vmName;
      } else if (_self.curVmName !== barConfig.vmName) {
        _self.curVmName = barConfig.vmName;
      } else if (_self.curVmName === barConfig.vmName) {
        _self.curVmName = '';
      }
    });
  },
  methods: {
    isearchResultShow: function isearchResultShow(result) {
      this.toolObject['ISearch'].getLayers();
      this.toolObject['ISearch'].resultData = result;
      this.curVmName = 'ISearch';
    },
    activeMapClick: function activeMapClick() {
      var _self = this;
      var handle = this.map.on('click', function (e) {
        var currentInfo = _self.toolObject['ISearch'].currentInfo;
        _self.$emit('mapClikc', e, currentInfo.currentUrl);
      });
      return handle;
    },

    loadEsriAPI: function loadEsriAPI() {
      var _this2 = this;

      if (!__WEBPACK_IMPORTED_MODULE_0_esri_loader__["isLoaded"]()) {
        __WEBPACK_IMPORTED_MODULE_0_esri_loader__["bootstrap"](function (err) {
          if (err) {
            console.error(err);
          }
          _this2.initMap();
        }, {
          url: 'http://' + window.systemIp + '/arcgis_js_api/library/3.19/3.19/init.js'
        });
      } else {
        this.initMap();
      }
    },
    initMap: function initMap() {
      var _this3 = this;

      this.esriLoader.dojoRequire(['esri/map', 'esri/geometry/Extent', 'tdlib/TianDiTuLayer', 'esri/tasks/query', 'esri/tasks/QueryTask', 'esri/config'], function (Map, Extent, TianDiTuLayer, Query, QueryTask, esriConfig) {
        if (_this3.proxyUrl) {
          esriConfig.defaults.io.proxyUrl = _this3.proxyUrl;
        }
        _this3.map = new Map(_this3.elId, {
          extent: new Extent(_this3.extention),
          logo: false,
          slider: false,
          showLabels: true
        });

        _this3.map.initExtent = _this3.map.extent;
        if (_this3.isAddBaseMap) {
          var baseMapLayer = new TianDiTuLayer('矢量底图', {
            id: 'baseMap'
          });
          _this3.map.addLayer(baseMapLayer);
          var baseLabelLayer = new TianDiTuLayer('矢量标注', {
            id: 'baseLabel'
          });
          _this3.map.addLayer(baseLabelLayer);
        }
        _this3.$on('mapClikc', function (e, currentUrl) {
          if (!currentUrl) {
            return;
          }
          var mp = e.mapPoint;
          var pad = _this3.map.extent.getWidth() / _this3.map.width * 3;
          var queryGeom = new Extent(mp.x - pad, mp.y - pad, mp.x + pad, mp.y + pad, _this3.map.spatialReference);
          var q = new Query();
          q.outSpatialReference = _this3.map.spatialReference;
          q.returnGeometry = true;
          q.where = '1=1';
          q.outFields = ['*'];
          q.geometry = queryGeom;
          var qt;
          qt = new QueryTask(currentUrl);
          qt.execute(q, _this3.isearchResultShow, function (e) {
            if (console) {
              console.log(e);
            }
          });
        });
        _this3.$emit('mapReady', _this3);
      });
    },
    setMapCompsStyle: function setMapCompsStyle(el, styleOptions) {
      if (el && styleOptions) {
        for (var propName in styleOptions) {
          el.style[propName] = styleOptions[propName];
        }
      }
    },
    setMapTypeLocate: function setMapTypeLocate(styleOptions) {
      this.setMapCompsStyle(this.$refs.maptype, styleOptions);
    },
    setMapLegendLocate: function setMapLegendLocate(styleOptions) {
      this.setMapCompsStyle(this.$refs.legend, styleOptions);
    },
    setMapToolLocate: function setMapToolLocate(styleOptions) {
      this.setMapCompsStyle(this.$refs.toolbar, styleOptions);
    },
    setOverviewMapLocate: function setOverviewMapLocate(styleOptions) {
      this.setMapCompsStyle(this.$refs.overview, styleOptions);
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// has ArcGIS API been loaded on the page yet?
function isLoaded() {
    // would like to just use window.require, but fucking typescript
    return typeof window['require'] !== 'undefined';
}
exports.isLoaded = isLoaded;
// load the ArcGIS API on the page
function bootstrap(callback, options) {
    if (options === void 0) { options = {}; }
    // default options
    if (!options.url) {
        options.url = 'https://js.arcgis.com/4.2/';
    }
    // don't reload API if it is already loaded
    if (isLoaded()) {
        callback(new Error('The ArcGIS API for JavaScript is already loaded.'));
        return;
    }
    // create a script object whose source points to the API
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = options.url;
    // once the script is loaded...
    script.onload = function () {
        // we can now use Dojo's require() to load esri and dojo AMD modules
        var dojoRequire = window['require'];
        // let the caller know that the API has been successfully loaded
        // and as a convenience, return the require function 
        // in case they want to use it directly
        callback(null, dojoRequire);
    };
    // load the script
    document.body.appendChild(script);
}
exports.bootstrap = bootstrap;
// prevent people from getting require undefined error
function dojoRequire(modules, callback) {
    if (!isLoaded()) {
        throw new Error('The ArcGIS API for JavaScript has not been loaded. You must first call esriLoader.bootstrap()');
    }
    else {
        window['require'](modules, callback);
    }
}
exports.dojoRequire = dojoRequire;
//# sourceMappingURL=index.js.map

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "mapContent",
    staticClass: "map-container"
  }, [_c('div', {
    staticClass: "map-box",
    attrs: {
      "id": _vm.elId
    }
  }, [_c('div', {
    ref: "toolbar",
    staticClass: "toolbar-wrapper"
  }, [_vm._t("toolbar"), _vm._v(" "), _c('div', {
    staticClass: "barboard-wrapper"
  }, [_c('keep-alive', [(!((_vm.curVmName + 'position' in _vm.toolObject) && _vm.toolObject[_vm.curVmName + 'position'] === 'center')) ? _c(_vm.$options.components[_vm.curVmName], {
    tag: "component",
    attrs: {
      "barVm": _vm.toolObject[_vm.curVmName]
    }
  }) : _vm._e()], 1)], 1)], 2), _vm._v(" "), ((_vm.curVmName + 'position' in _vm.toolObject) && _vm.toolObject[_vm.curVmName + 'position'] === 'center') ? _c(_vm.$options.components[_vm.curVmName], {
    tag: "component",
    attrs: {
      "barVm": _vm.toolObject[_vm.curVmName]
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "maptype",
    staticClass: "maptype-wrapper"
  }, [_vm._t("mapType")], 2), _vm._v(" "), _c('div', {
    ref: "legend",
    staticClass: "legend-wrapper"
  }, [_vm._t("mapLegend")], 2), _vm._v(" "), _c('div', {
    ref: "overview",
    staticClass: "overview-wrapper"
  }, [_vm._t("overviewMap")], 2), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(13)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(15),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MapLegend',
  data: function data() {
    return {
      isLoaderAdded: false,
      arcgisClass: null,
      show: true,
      flag: true };
  },

  props: {
    mapConfig: {
      map: {
        type: Object,
        required: true
      },
      esriLoader: {
        type: Object,
        required: true
      }
    },
    elId: {
      type: String,
      default: 'overview',
      required: true
    },
    layerInfos: {
      required: false
    }
  },
  watch: {
    mapConfig: function mapConfig(value) {
      if (value.map != null && !this.isLoaderAdded) {
        this.initEsriLoaders();
      }
    },
    isLoaderAdded: function isLoaderAdded(val) {
      if (val) {
        this.initMapLegend(this.layerInfos);
      }
    },
    layerInfos: function layerInfos(value) {
      if (value && value.length > 0 && this.isLoaderAdded) {
        this.initMapLegend(value);
      }
    },
    flag: function flag() {}
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$events.$on('mapTypeChange', function (data) {
      _this2.initMapLegend(_this2.layerInfos);
    });
  },
  methods: {
    hiddenLegend: function hiddenLegend() {
      var pluArrow = document.getElementsByClassName('plugin-arrow-legend')[0];
      if (this.flag === false) {
        pluArrow = document.getElementsByClassName('top-arrow-legend')[0];
      }
      var legendContainer = document.getElementsByClassName('legend-container')[0];
      var containerState = legendContainer.style.display;
      var ele = pluArrow;
      if (containerState === 'none') {
        while (ele.className !== 'legend-wrapper') {
          ele = ele.parentElement;
        }
        ele.style.width = '170px';
        ele.style.height = '200px';
        legendContainer.style.display = 'block';

        ele.style.backgroundColor = '#0a162c';
        ele.style.overflowY = 'auto';
        ele.style.boxShadow = '0 0 10px #666';
        this.flag = true;
      } else {
        while (ele.className !== 'legend-wrapper') {
          ele = ele.parentElement;
        }
        ele.style.width = '15px';
        ele.style.height = '15px';

        ele.style.overflowY = '';
        ele.style.boxShadow = '';
        ele.style.backgroundColor = '#0a162c';
        legendContainer.style.display = 'none';
        this.flag = false;
      }
    },
    showLegendNone: function showLegendNone() {
      document.getElementsByClassName('legend-wrapper')[0].style.background = 'linear-gradient(to bottom, #0a162c, #0a2f4d)';
      document.getElementById('maplegend').style.background = '#0a162c';
      document.getElementsByClassName('legend-container')[0].style.background = '#0a162c';
    },
    showLegendBackground: function showLegendBackground() {
      document.getElementById('maplegend').style.background = 'linear-gradient(to bottom, #0a162c, #0a2f4d)';
    },
    initEsriLoaders: function initEsriLoaders() {
      var _this3 = this;

      this.mapConfig.esriLoader.dojoRequire(['esri/dijit/Legend'], function (Legend) {
        _this3.arcgisClass = { Legend: Legend };
        _this3.isLoaderAdded = true;
      });
    },
    initMapLegend: function initMapLegend(layInfos) {
      if (this.$refs.legendContainer.children.length === 0) {
        var legendEl = window.document.createElement('div');
        legendEl.id = this.elId;
        legendEl.className = 'legend';
        this.$refs.legendContainer.appendChild(legendEl);
      }
      var _this = this;
      this.$nextTick(function () {
        if (!this.mapConfig.map.featureLegend) {
          this.mapConfig.map.featureLegend = new this.arcgisClass.Legend({
            map: _this.mapConfig.map,
            layerInfos: layInfos
          }, _this.elId);
          this.mapConfig.map.featureLegend.startup();
        } else {
          this.mapConfig.map.featureLegend.layerInfos = layInfos;
          this.mapConfig.map.featureLegend.refresh();
        }
        this.isLoaderAdded = true;
      });
    },

    animate: function animate(obj, json, interval, sp, fn) {
      clearInterval(obj.timer);
      function getStyle(obj, arr) {
        if (obj.currentStyle) {
          return obj.currentStyle[arr];
        } else {
          return document.defaultView.getComputedStyle(obj, null)[arr];
        }
      }
      obj.timer = setInterval(function () {
        var flag = true;
        for (var arr in json) {
          var icur = 0;
          if (arr === 'opacity') {
            icur = Math.round(parseFloat(getStyle(obj, arr)) * 100);
          } else {
            icur = parseInt(getStyle(obj, arr));
          }
          var speed = (json[arr] - icur) * sp;
          speed = speed > 0 ? Math.ceil(speed) : Math.floor(speed);
          if (icur !== json[arr]) {
            flag = false;
          }
          if (arr === 'opacity') {
            obj.style.filter = "alpha(opacity : '+(icur + speed)+' )";
            obj.style.opacity = (icur + speed) / 100;
          } else {
            obj.style[arr] = icur + speed + 'px';
          }
        }

        if (flag) {
          clearInterval(obj.timer);
          if (fn) {
            fn();
          }
        }
      }, interval);
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-box"
  }, [_c('div', {
    class: [_vm.flag ? 'plugin-arrow-legend' : 'top-arrow-legend'],
    on: {
      "click": _vm.hiddenLegend
    }
  }), _vm._v(" "), (_vm.show) ? _c('div', {
    ref: "legendContainer",
    staticClass: "legend-container"
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fullExtent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fullExtent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fullExtent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fullScreen__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fullScreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fullScreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__iSearch_board__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__iSearch_board___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__iSearch_board__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__iSearch__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__iSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__iSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__location_board__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__location_board___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__location_board__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__location__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__location___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__location__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__measurement__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__measurement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__measurement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__measure_board__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__measure_board___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__measure_board__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__renderClear__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__renderClear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__renderClear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__search_board__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__search_board___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__search_board__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__search__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zoomIn__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zoomIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zoomIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zoomOut__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zoomOut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zoomOut__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__fullExtent___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__fullScreen___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__iSearch_board___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__iSearch___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__location_board___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__location___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__measurement___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__measure_board___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__renderClear___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_9__search_board___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_10__search___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__zoomIn___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_12__zoomOut___default.a; });





























/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(18)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(20),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FullExtent',
  data: function data() {
    return {
      msg: 'full-extent'
    };
  },

  props: {
    mapConfig: {
      map: {
        type: Object,
        required: true
      },
      esriLoader: {
        type: Object,
        required: true
      }
    }
  },
  methods: {
    setFullExtent: function setFullExtent() {
      this.mapConfig.map.setExtent(this.mapConfig.map.initExtent || this.mapConfig.map.extent);
    }
  }
});

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-extent-container",
    on: {
      "click": _vm.setFullExtent
    }
  }, [_c('div', {
    staticClass: "icon"
  })])
},staticRenderFns: []}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(22)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(24),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FullScreen',
  data: function data() {
    return {
      isFullScreen: false
    };
  },

  methods: {
    toggleFullScreen: function toggleFullScreen() {
      var el = this.$parent.$refs.mapContent || this.$parent.$parent.$refs.mapContent;
      if (!el.classList.contains('all-screen')) {
        el.classList.add('all-screen');
        this.isFullScreen = true;
      } else {
        el.classList.remove('all-screen');
        this.isFullScreen = false;
      }
    }
  }
});

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-screen-container",
    on: {
      "click": _vm.toggleFullScreen
    }
  }, [_c('div', {
    staticClass: "icon",
    class: {
      activated: _vm.isFullScreen
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ISearchBoard',
  props: ['barVm'],
  data: function data() {
    return {
      isFold: true,

      showMove: false,

      position: {
        x: null,
        y: null
      }
    };
  },

  computed: {
    layerInfo: function layerInfo() {
      return this.barVm.layerInfo;
    },
    currentInfo: function currentInfo() {
      return this.barVm.currentInfo;
    },
    resultData: function resultData() {
      var featureAttributes = null;

      var resultData = this.barVm.resultData;
      if (resultData) {
        featureAttributes = resultData.features.length > 0 ? resultData.features[0].attributes : null;
      }
      return featureAttributes;
    },
    fieldsInfo: function fieldsInfo() {
      return this.barVm.resultData.fields;
    }
  },
  mounted: function mounted() {},

  filters: {
    getAliasName: function getAliasName(fieldname, fields) {
      for (var field in fields) {
        if (fields[field].name === fieldname) {
          return fields[field].alias;
        }
      }
      return fieldname;
    }
  },
  methods: {
    isShow: function isShow(key) {
      if (window.isearchNotShowFields === null || window.isearchNotShowFields.length === 0) {
        return true;
      }
      if (window.isearchNotShowFields.indexOf(key) > -1 || window.isearchNotShowFields.indexOf(key.toLocaleLowerCase) > -1) {
        return false;
      } else {
        return true;
      }
    },
    contentMouseDown: function contentMouseDown(e) {
      this.showMove = true;
      e = this.fixEvent(e);
      e.preventDefault && e.preventDefault();
      this.position.x = e.clientX - this.$el.offsetLeft;
      this.position.y = e.clientY - this.$el.offsetTop;
      this.$el.onmousemove = this.startMove;
      this.$el.onmouseup = this.endMove;
    },
    startMove: function startMove(e) {
      e = this.fixEvent(e);
      var oLeft = e.clientX - this.position.x;
      var oTop = e.clientY - this.position.y;
      this.$el.style.left = oLeft + 'px';
      this.$el.style.top = oTop + 'px';
    },
    endMove: function endMove(e) {
      this.showMove = false;
      this.$el.onmousemove = this.$el.onmouseup = null;
    },
    fixEvent: function fixEvent(e) {
      if (!e) {
        e = window.event;
        e.target = e.srcElement;
        e.layerX = e.offsetX;
        e.layerY = e.offsetY;
      }
      return e;
    },
    closeClick: function closeClick() {
      this.$events.$emit('barItemClick', { vmName: null });
    },
    contentClick: function contentClick() {
      this.isFold = true;
    },
    layerSelectClick: function layerSelectClick() {
      this.isFold = false;
    },
    itemClick: function itemClick(obj) {
      this.barVm.currentInfo = obj;
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "isearch-board",
    style: ([_vm.showMove ? {
      cursor: 'move'
    } : null]),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.contentClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "info-window-title",
    on: {
      "mousedown": _vm.contentMouseDown
    }
  }, [_c('div', {
    staticClass: "info-window-title-value"
  }, [_vm._v("属性信息")]), _vm._v(" "), _c('div', {
    staticClass: "info-window-close",
    on: {
      "click": _vm.closeClick
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-window-layer-select-Content",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.layerSelectClick($event)
      }
    }
  }, [_c('input', {
    staticClass: "info-window-layer-select",
    attrs: {
      "type": "text",
      "disabled": "true"
    },
    domProps: {
      "value": _vm.currentInfo.currentName
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.isFold ? 'info-window-layer-select-icon-fold' : 'info-window-layer-select-icon-spread']
  })]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFold),
      expression: "!isFold"
    }],
    staticClass: "info-window-layer-select-list"
  }, _vm._l((_vm.layerInfo), function(item) {
    return _c('li', {
      staticClass: "list-item",
      on: {
        "click": function($event) {
          _vm.itemClick(item)
        }
      }
    }, [_c('span', {
      staticClass: "show-info"
    }, [_vm._v(_vm._s(item.currentName))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "info-window-content"
  }, [_c('ul', {
    staticClass: "info-window-content-ul"
  }, _vm._l((_vm.resultData), function(value, key) {
    return (_vm.isShow(key)) ? _c('li', {
      staticClass: "info-item"
    }, [_c('span', {
      staticClass: "field-key"
    }, [_vm._v(_vm._s(_vm._f("getAliasName")(key, _vm.fieldsInfo)))]), _vm._v(" "), _c('span', {
      staticClass: "field-value"
    }, [_vm._v(_vm._s(value))])]) : _vm._e()
  }))])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(29)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(31),
  /* scopeId */
  "data-v-24061d02",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__iSearch_board__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__iSearch_board___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__iSearch_board__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ISearch',
  props: {
    mapConfig: {
      map: {
        type: Object,
        required: true
      },
      esriLoader: {
        type: Object,
        required: true
      }
    }
  },
  mounted: function mounted() {
    this.$events.$emit('barItemBoardInited', this.$options.name, this.dashboard, this, 'center');
  },
  data: function data() {
    return {
      dashboard: __WEBPACK_IMPORTED_MODULE_0__iSearch_board___default.a,
      Extent: {},
      Query: {},
      QueryTask: {},
      mapClickEvent: null,
      isStart: false,
      currentInfo: {
        currentUrl: null,
        currentName: null
      },
      layerInfo: [],
      resultData: null,
      active: false
    };
  },
  created: function created() {
    var _self = this;
    if (this.mapConfig.esriLoader) {
      this.mapConfig.esriLoader.dojoRequire(['esri/geometry/Extent', 'esri/tasks/query', 'esri/tasks/QueryTask'], function (Extent, Query, QueryTask) {
        _self.Extent = Extent;
        _self.Query = Query;
        _self.QueryTask = QueryTask;
      });
    }
  },

  methods: {
    getLayers: function getLayers() {
      this.layerInfo = [];

      var layers = this.mapConfig.map.getLayersVisibleAtScale();

      for (var k = 0; k < layers.length; k++) {
        if (layers[k].layerInfos) {
          for (var m = 0; m < layers[k].layerInfos.length; m++) {
            if (layers[k].layerInfos[m].name === undefined) {
              continue;
            }
            var layerid = layers[k].layerInfos[m].id;
            if (layers[k].visibleLayers.indexOf(layerid) < 0) {
              continue;
            }
            var obj = {
              currentName: layers[k].id + '_' + layers[k].layerInfos[m].name,
              currentUrl: layers[k].url + '/' + layerid
            };
            if (!this.currentInfo.currentName) {
              this.currentInfo = obj;
            }
            this.layerInfo.push(obj);
          }
        } else {
          if (layers[k].name === undefined) {
            continue;
          }
          var _obj = {
            currentName: layers[k].name,
            currentUrl: layers[k].url
          };
          if (!this.currentInfo.currentName) {
            this.currentInfo = _obj;
          }
          this.layerInfo.push(_obj);
        }
      }
    },
    iSearchClick: function iSearchClick() {
      this.$events.$emit('barItemClick', { vmName: this.$options.name });
      this.getLayers();
    },
    startSearch: function startSearch() {
      var _self = this;
      var map = this.mapConfig.map;
      var EsriExtent = this.Extent;
      var EsriQuery = this.Query;
      var EsriQueryTask = this.QueryTask;

      this.mapClickEvent = map.on('click', function (e) {
        var mp = e.mapPoint;
        var pad = map.extent.getWidth() / map.width * 3;

        var queryGeom = new EsriExtent(mp.x - pad, mp.y - pad, mp.x + pad, mp.y + pad, map.spatialReference);

        var query = new EsriQuery();

        query.outSpatialReference = map.spatialReference;

        query.returnGeometry = true;

        query.where = '1=1';

        query.outFields = ['*'];

        query.geometry = queryGeom;

        var qt = new EsriQueryTask(_self.currentUrl);

        qt.execute(query, _self.showResult, function (e) {
          if (console) {
            console.log(e);
          }
        });
      });
    },
    getFirstLayerUrl: function getFirstLayerUrl() {
      var layers = this.mapConfig.map.getLayersVisibleAtScale();
      var layer;

      for (var i = layers.length - 1; i >= 0; i--) {
        layer = layers[i];

        if (layer.name !== undefined || layer.layerInfos !== undefined) {
          break;
        }
      }

      if (layer === undefined) {
        return null;
      }

      if (layer.layerInfos) {
        return layer.url + '/' + layer.layerInfos[0].id;
      } else {
        return layer.url;
      }
    }
  }
});

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "isearch-container",
    on: {
      "click": _vm.iSearchClick
    }
  }, [_c('div', {
    staticClass: "icon",
    class: {
      'active-control': _vm.active
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LocationBoard',
  data: function data() {
    return {
      msg: 'locationBoard'
    };
  },

  props: ['barVm'],
  computed: {
    locationLst: function locationLst() {
      if (this.barVm.curUrlConfig.url) {
        return this.barVm.curUrlConfig.dataArray;
      }
    }
  },
  methods: {
    locate: function locate(center) {
      this.barVm.mapConfig.map.centerAt(center);
    }
  }
});

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "locationboard-container"
  }, [_c('ul', {
    staticClass: "location-list"
  }, _vm._l((_vm.locationLst), function(location) {
    return _c('li', {
      key: location.id,
      staticClass: "location-item",
      on: {
        "click": function($event) {
          _vm.locate(location.center)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(location.name))])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(36)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(38),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__location_board__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__location_board___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__location_board__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Location',
  data: function data() {
    return {
      dashboard: __WEBPACK_IMPORTED_MODULE_0__location_board___default.a,
      curLocation: '',
      curMapLevel: -1,
      urlConfig: [{
        minLevel: 0,
        maxLevel: 13,
        url: 'http://' + window.gisServerIp + '/arcgis/rest/services/GISIOC/jc_town_wgs84_dt/MapServer',
        field: {
          id: 'objectid_1',
          name: 'name'
        },
        index: 0,
        dataArray: []
      }, {
        minLevel: 13,
        maxLevel: 19,
        url: 'http://' + window.gisServerIp + '/arcgis/rest/services/GISIOC/jc_xzqh_wgs84_dt/MapServer',
        field: {
          id: 'qhdm',
          name: 'qhmc'
        },
        index: 2,
        dataArray: []
      }],
      curUrlConfig: null,
      serverUrl: '',
      identifyTask: null,
      identifyParams: null,
      showBarBoard: false
    };
  },

  props: {
    mapConfig: {
      map: {
        type: Object,
        required: true
      },
      esriLoader: {
        type: Object,
        required: true
      }
    }
  },
  watch: {
    mapConfig: function mapConfig(val, oldVal) {
      if (val.map != null && oldVal.map == null) {
        this.getMapZoomLevel();
        this.mapConfig.map.on('zoom', this.getMapZoomLevel);
        this.getLayerData();
        this.getIdentifyConfig();
        this.locationIdentify();
        this.mapConfig.map.on('extent-change', this.locationIdentify);
      }
    }
  },
  mounted: function mounted() {
    this.$events.$emit('barItemBoardInited', this.$options.name, this.dashboard, this);
  },
  methods: {
    getMapZoomLevel: function getMapZoomLevel() {
      this.curMapLevel = this.mapConfig.map.getLevel();
      this.getServerUrl();
      this.getCurUrlConfig();
    },
    getServerUrl: function getServerUrl() {
      var _this = this;

      var result = this.urlConfig[0].url;
      this.urlConfig.forEach(function (item) {
        if (item.minLevel <= _this.curMapLevel && item.maxLevel > _this.curMapLevel) {
          result = item.url;
          return;
        }
      }, this);
      this.serverUrl = result;
    },
    getCurUrlConfig: function getCurUrlConfig() {
      var _this2 = this;

      var result = this.urlConfig[0];
      this.urlConfig.forEach(function (item) {
        if (item.minLevel <= _this2.curMapLevel && item.maxLevel > _this2.curMapLevel) {
          result = item;
          return;
        }
      }, this);
      this.curUrlConfig = result;
    },
    getIdentifyConfig: function getIdentifyConfig() {
      var _self = this;
      this.mapConfig.esriLoader.dojoRequire(['esri/tasks/IdentifyParameters'], function (IdentifyParameters) {
        _self.identifyParams = new IdentifyParameters();
        _self.identifyParams.tolerance = 3;
        _self.identifyParams.returnGeometry = true;
        _self.identifyParams.layerIds = [0, 1];
        _self.identifyParams.layerOption = IdentifyParameters.LAYER_OPTION_ALL;
        _self.identifyParams.width = _self.mapConfig.map.width;
        _self.identifyParams.height = _self.mapConfig.map.height;
      });
    },
    locationIdentify: function locationIdentify() {
      var _self = this;
      this.mapConfig.esriLoader.dojoRequire(['esri/tasks/IdentifyTask', 'esri/geometry/Point'], function (IdentifyTask, Point) {
        _self.identifyTask = new IdentifyTask(_self.serverUrl);
        _self.identifyParams.geometry = new Point(_self.mapConfig.map.extent.getCenter());
        _self.identifyParams.mapExtent = _self.mapConfig.map.extent;
        _self.identifyTask.execute(_self.identifyParams).addCallback(function (response) {
          window.dojo.map(response, function (result) {
            _self.curLocation = result.value;
          });
        });
      });
    },
    changeBoardState: function changeBoardState() {
      this.$events.$emit('barItemClick', { vmName: this.$options.name, boardData: this.curUrlConfig.dataArray });
      this.$events.$emit('initDashboardData', this.curUrlConfig.dataArray);
    },
    getLayerData: function getLayerData() {
      var _self = this;
      this.mapConfig.esriLoader.dojoRequire(['esri/tasks/query', 'esri/layers/FeatureLayer', 'esri/geometry/Extent'], function (Query, FeatureLayer, Extent) {
        _self.urlConfig.forEach(function (item) {
          var url = item.url + '/' + item.index;
          var fealyr = new FeatureLayer(url);
          var query = new Query();
          query.outFields = ['*'];
          query.where = '1=1';
          fealyr.queryFeatures(query, function (featureSet) {
            featureSet.features.forEach(function (feature) {
              var id = feature.attributes[item.field.id];
              var name = feature.attributes[item.field.name];
              var center = feature.geometry.getExtent().getCenter();
              item.dataArray.push({ id: id, name: name, center: center });
            }, _self);
          });
        });
      });
    }
  }
});

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "location-container",
    on: {
      "click": _vm.changeBoardState
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.curLocation))])])
},staticRenderFns: []}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(40)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(45),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__measure_board__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__measure_board___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__measure_board__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Measurement',
  data: function data() {
    return {
      dashboard: __WEBPACK_IMPORTED_MODULE_0__measure_board___default.a,
      esriClass: null
    };
  },

  props: {
    mapConfig: {
      map: {
        type: Object,
        default: null
      },
      esriLoader: {
        type: Object
      }
    },
    elId: {
      type: String,
      required: true,
      default: 'measureboard'
    }
  },
  watch: {
    mapConfig: function mapConfig(val, oldVal) {
      if (val.map != null && oldVal.map == null) {
        this.initEsriClass();
      }
    }
  },
  mounted: function mounted() {
    this.$events.$emit('barItemBoardInited', this.$options.name, this.dashboard, this);
  },
  methods: {
    initEsriClass: function initEsriClass() {
      var _this = this;

      this.mapConfig.esriLoader.dojoRequire(['esri/dijit/Measurement', 'esri/units', 'dojo/dom'], function (Measurement, Units, dom) {
        _this.esriClass = { Measurement: Measurement, Units: Units, dom: dom };
      });
    },
    initMeasureBoard: function initMeasureBoard(el) {
      if (el && this.esriClass) {
        el.id = this.elId;
        this.mapConfig.map.measurement = this.esriClass.Measurement({
          map: this.mapConfig.map,
          defaultAreaUnit: this.esriClass.Units.SQUARE_METERS,
          defaultLengthUnit: this.esriClass.Units.METERS
        }, this.esriClass.dom.byId(this.elId));
        this.mapConfig.map.measurement.startup();
      };
    },
    changeBoardState: function changeBoardState() {
      this.$events.$emit('barItemClick', { vmName: this.$options.name });
    }
  }
});

/***/ }),
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MeasurementBoard',
    data: function data() {
        return {
            meg: 'measure board'
        };
    },

    props: ['barVm'],
    mounted: function mounted() {
        this.barVm.initMeasureBoard(this.$refs.measureboard);
    },
    activated: function activated() {},
    deactivated: function deactivated() {
        this.barVm.mapConfig.map.measurement.clearResult();
        this.barVm.mapConfig.map.measurement.setTool('location', false);
        this.barVm.mapConfig.map.measurement.setTool('distance', false);
        this.barVm.mapConfig.map.measurement.setTool('area', false);
    }
});

/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "measureboard-container"
  }, [_c('div', {
    ref: "measureboard",
    staticClass: "measureboard"
  })])
},staticRenderFns: []}

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "measurement-container",
    on: {
      "click": _vm.changeBoardState
    }
  }, [_c('div', {
    staticClass: "icon"
  })])
},staticRenderFns: []}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(47)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(49),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RenderClear',
  data: function data() {
    return {
      msg: 'render-clear'
    };
  },

  props: ['map', 'clearCallBack'],
  methods: {
    clearRender: function clearRender() {
      if (this.clearCallBack) {
        this.clearCallBack();
      }
    }
  }
});

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "render-clear-container",
    on: {
      "click": _vm.clearRender
    }
  }, [_c('div', {
    staticClass: "icon"
  })])
},staticRenderFns: []}

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bmap_coordinateConvert__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__image_map_search_red_1_png__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__image_map_search_red_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__image_map_search_red_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__image_map_search_red_2_png__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__image_map_search_red_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__image_map_search_red_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__image_map_search_red_3_png__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__image_map_search_red_3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__image_map_search_red_3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__image_map_search_red_4_png__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__image_map_search_red_4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__image_map_search_red_4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__image_map_search_red_5_png__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__image_map_search_red_5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__image_map_search_red_5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__image_map_search_red_6_png__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__image_map_search_red_6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__image_map_search_red_6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__image_map_search_red_7_png__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__image_map_search_red_7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__image_map_search_red_7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__image_map_search_red_8_png__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__image_map_search_red_8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__image_map_search_red_8_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__image_map_search_red_9_png__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__image_map_search_red_9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__image_map_search_red_9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__image_map_search_red_10_png__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__image_map_search_red_10_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__image_map_search_red_10_png__);














/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SearchBoard',
    data: function data() {
        return {
            msg: 'search-board',
            keywords: '',
            localSearch: null,
            maxLength: 10,
            resultData: [],
            imgObj: {}
        };
    },

    props: ['barVm'],
    activated: function activated() {
        this.$nextTick(function () {
            this.$refs.input.focus();
        });
    },
    deactivated: function deactivated() {
        this.barVm.mapConfig.map.searchPointGhLayer.hide();
    },
    mounted: function mounted() {
        this.initBmapControl();
        this.imgObj = {
            pointLabel1: __WEBPACK_IMPORTED_MODULE_1__image_map_search_red_1_png___default.a,
            pointLabel2: __WEBPACK_IMPORTED_MODULE_2__image_map_search_red_2_png___default.a,
            pointLabel3: __WEBPACK_IMPORTED_MODULE_3__image_map_search_red_3_png___default.a,
            pointLabel4: __WEBPACK_IMPORTED_MODULE_4__image_map_search_red_4_png___default.a,
            pointLabel5: __WEBPACK_IMPORTED_MODULE_5__image_map_search_red_5_png___default.a,
            pointLabel6: __WEBPACK_IMPORTED_MODULE_6__image_map_search_red_6_png___default.a,
            pointLabel7: __WEBPACK_IMPORTED_MODULE_7__image_map_search_red_7_png___default.a,
            pointLabel8: __WEBPACK_IMPORTED_MODULE_8__image_map_search_red_8_png___default.a,
            pointLabel9: __WEBPACK_IMPORTED_MODULE_9__image_map_search_red_9_png___default.a,
            pointLabel10: __WEBPACK_IMPORTED_MODULE_10__image_map_search_red_10_png___default.a
        };
    },
    methods: {
        searchHandler: function searchHandler() {
            if (!this.barVm.mapConfig.map.getLayer('searchPointGhLayer')) {
                this.barVm.mapConfig.map.addLayer(this.barVm.mapConfig.map.searchPointGhLayer);
            }
            this.barVm.mapConfig.map.searchPointGhLayer.show();
            if (this.keywords) {
                this.localSearch.search(this.keywords);
            }
        },
        initBmapControl: function initBmapControl() {
            var _this = this;

            if (!this.barVm.mapConfig.map.searchPointGhLayer) {
                this.barVm.mapConfig.map.searchPointGhLayer = new this.barVm.arcgisClass.GraphicsLayer({
                    id: 'searchPointGhLayer'
                });
            }
            var bmap = new window.BMap.Map('baidumapcontain');
            this.localSearch = new window.BMap.LocalSearch(bmap);
            bmap.centerAndZoom('昆明', 12);
            this.localSearch.setSearchCompleteCallback(function (searchResult) {
                _this.clearOldPoint();
                _this.resultData.length = 0;
                if (searchResult.getNumPois() > 0) {
                    for (var i = 0; i < _this.maxLength; i++) {
                        var bPoi = searchResult.getPoi(i);
                        var tdPoi = _this.coorConvert(bPoi);
                        var point = new _this.barVm.arcgisClass.Point({
                            spatialReference: {
                                'wkid': 4326
                            },
                            type: 'point',
                            x: tdPoi.lon,
                            y: tdPoi.lat
                        });
                        bPoi.point = point;
                        bPoi.imgObj = _this.imgObj['pointLabel' + (i + 1)];
                        bPoi.imgPosi = -i * 21;
                        _this.resultData.push(bPoi);
                        _this.drawPointAtMap(bPoi);
                    }
                }
            });
        },
        clearOldPoint: function clearOldPoint() {
            this.barVm.mapConfig.map.searchPointGhLayer.clear();
        },
        drawPointAtMap: function drawPointAtMap(poi) {
            var pms = new this.barVm.arcgisClass.PictureMarkerSymbol(poi.imgObj, 21, 31);
            var attributes = {
                title: poi.title,
                address: poi.address,
                telephone: poi.phoneNumber
            };
            var graphic = new this.barVm.arcgisClass.Graphic(poi.point, pms, attributes);
            this.barVm.mapConfig.map.searchPointGhLayer.add(graphic);
        },
        locate: function locate(point) {
            this.barVm.mapConfig.map.centerAndZoom(point, 16);
        },
        coorConvert: function coorConvert(bPoi) {
            var bdtogcjPoint = __WEBPACK_IMPORTED_MODULE_0__bmap_coordinateConvert__["a" /* default */].bd_decrypt(bPoi.point.lat, bPoi.point.lng);
            var gcjtowgsPoint = __WEBPACK_IMPORTED_MODULE_0__bmap_coordinateConvert__["a" /* default */].gcj_decrypt_exact(bdtogcjPoint.lat, bdtogcjPoint.lon);
            return gcjtowgsPoint;
        }
    }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  PI: 3.14159265358979324,
  x_pi: 3.14159265358979324 * 3000.0 / 180.0,
  delta: function delta(lat, lon) {
    var a = 6378245.0;
    var ee = 0.00669342162296594323;
    var dLat = this.transformLat(lon - 105.0, lat - 35.0);
    var dLon = this.transformLon(lon - 105.0, lat - 35.0);
    var radLat = lat / 180.0 * this.PI;
    var magic = Math.sin(radLat);
    magic = 1 - ee * magic * magic;
    var sqrtMagic = Math.sqrt(magic);
    dLat = dLat * 180.0 / (a * (1 - ee) / (magic * sqrtMagic) * this.PI);
    dLon = dLon * 180.0 / (a / sqrtMagic * Math.cos(radLat) * this.PI);
    return {
      'lat': dLat,
      'lon': dLon
    };
  },

  gcj_encrypt: function gcj_encrypt(wgsLat, wgsLon) {
    if (this.outOfChina(wgsLat, wgsLon)) {
      return {
        'lat': wgsLat,
        'lon': wgsLon
      };
    }
    var d = this.delta(wgsLat, wgsLon);
    return {
      'lat': wgsLat + d.lat,
      'lon': wgsLon + d.lon
    };
  },

  gcj_decrypt: function gcj_decrypt(gcjLat, gcjLon) {
    if (this.outOfChina(gcjLat, gcjLon)) {
      return {
        'lat': gcjLat,
        'lon': gcjLon
      };
    }
    var d = this.delta(gcjLat, gcjLon);
    return {
      'lat': gcjLat - d.lat,
      'lon': gcjLon - d.lon
    };
  },

  gcj_decrypt_exact: function gcj_decrypt_exact(gcjLat, gcjLon) {
    var initDelta = 0.01;
    var threshold = 0.000000001;
    var dLat = initDelta;
    var dLon = initDelta;
    var mLat = gcjLat - dLat;
    var mLon = gcjLon - dLon;
    var pLat = gcjLat + dLat;
    var pLon = gcjLon + dLon;
    var wgsLat, wgsLon, i;
    i = 0;
    while (1) {
      wgsLat = (mLat + pLat) / 2;
      wgsLon = (mLon + pLon) / 2;
      var tmp = this.gcj_encrypt(wgsLat, wgsLon);
      dLat = tmp.lat - gcjLat;
      dLon = tmp.lon - gcjLon;
      if (Math.abs(dLat) < threshold && Math.abs(dLon) < threshold) {
        break;
      }
      if (dLat > 0) pLat = wgsLat;else mLat = wgsLat;
      if (dLon > 0) pLon = wgsLon;else mLon = wgsLon;

      if (++i > 10000) break;
    }

    return {
      'lat': wgsLat,
      'lon': wgsLon
    };
  },

  bd_encrypt: function bd_encrypt(gcjLat, gcjLon) {
    var x = gcjLon;
    var y = gcjLat;
    var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * this.x_pi);
    var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * this.x_pi);
    var bdLon = z * Math.cos(theta) + 0.0065;
    var bdLat = z * Math.sin(theta) + 0.006;
    return {
      'lat': bdLat,
      'lon': bdLon
    };
  },

  bd_decrypt: function bd_decrypt(bdLat, bdLon) {
    var x = bdLon - 0.0065;
    var y = bdLat - 0.006;
    var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * this.x_pi);
    var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * this.x_pi);
    var gcjLon = z * Math.cos(theta);
    var gcjLat = z * Math.sin(theta);
    return {
      'lat': gcjLat,
      'lon': gcjLon
    };
  },

  mercator_encrypt: function mercator_encrypt(wgsLat, wgsLon) {
    var x = wgsLon * 20037508.34 / 180;
    var y = Math.log(Math.tan((90 + wgsLat) * this.PI / 360)) / (this.PI / 180);
    y = y * 20037508.34 / 180;
    return {
      'lat': y,
      'lon': x
    };
  },

  mercator_decrypt: function mercator_decrypt(mercatorLat, mercatorLon) {
    var x = mercatorLon / 20037508.34 * 180;
    var y = mercatorLat / 20037508.34 * 180;
    y = 180 / this.PI * (2 * Math.atan(Math.exp(y * this.PI / 180)) - this.PI / 2);
    return {
      'lat': y,
      'lon': x
    };
  },

  distance: function distance(latA, lonA, latB, lonB) {
    var earthR = 6371000;
    var x = Math.cos(latA * this.PI / 180) * Math.cos(latB * this.PI / 180) * Math.cos((lonA - lonB) * this.PI / 180);
    var y = Math.sin(latA * this.PI / 180) * Math.sin(latB * this.PI / 180);
    var s = x + y;
    if (s > 1) s = 1;
    if (s < -1) s = -1;
    var alpha = Math.acos(s);
    var distance = alpha * earthR;
    return distance;
  },
  outOfChina: function outOfChina(lat, lon) {
    if (lon < 72.004 || lon > 137.8347) {
      return true;
    }
    if (lat < 0.8293 || lat > 55.8271) {
      return true;
    }
    return false;
  },
  transformLat: function transformLat(x, y) {
    var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
    ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(y * this.PI) + 40.0 * Math.sin(y / 3.0 * this.PI)) * 2.0 / 3.0;
    ret += (160.0 * Math.sin(y / 12.0 * this.PI) + 320 * Math.sin(y * this.PI / 30.0)) * 2.0 / 3.0;
    return ret;
  },
  transformLon: function transformLon(x, y) {
    var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
    ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(x * this.PI) + 40.0 * Math.sin(x / 3.0 * this.PI)) * 2.0 / 3.0;
    ret += (150.0 * Math.sin(x / 12.0 * this.PI) + 300.0 * Math.sin(x / 30.0 * this.PI)) * 2.0 / 3.0;
    return ret;
  }
});

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAfCAYAAAAIjIbwAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpBQTk5ODc2NjdFMzkxMUU2QkQyMEI4NkNERDlCMjI3RSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpBQTk5ODc2NzdFMzkxMUU2QkQyMEI4NkNERDlCMjI3RSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkFBOTk4NzY0N0UzOTExRTZCRDIwQjg2Q0REOUIyMjdFIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkFBOTk4NzY1N0UzOTExRTZCRDIwQjg2Q0REOUIyMjdFIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+nyFElQAAAoxJREFUeNqkls9LFVEUx8/Me5PvaSZk9GNT9EN3FbiwVRD9IG0RqEhR4KJNgiIItao/oJUYGNQiiHYtLJGin7yNgUkRQbuSqMiihaH5nj5nfHP7nvH2HMd777zRA9+5M/fc+3nnzD1z77OEEKSy+ZNHmtB0QKehBmgL9Bf6DD2HhqtfTbxXzbWiUMAa0QxBpyjeXkK9gH/SQgFsQ3Mf2kyVWx7qAvjRGiiAZ9E8hFKU3EpQO8CjZSiAB3DP76eW1m9zUBPAk7bsuBkHTB1vJat+u2kIzx8MIi2caD6M9oN2aDZLzqUecto6aXHgBvm5ZySKCyb4oTQuF3Ree9sOSnVeDICBFYskfJ8okwnuNdbO6R/Tpny+i5yOcyQW5lc6PRf5WaZIWxi6X18sc+QNP6ClJ6Oh8FEcrmuCNnD69Tqvd+920Drd/csdjoOLiKuCrbYs3srM84j4nZZ806gCQ78bQZxu+B0G98ZovzH0rda9qYoslNQqqO/H5fOOoSP6j69EopCPRAlLp03QEYY+hr6qU7eWAba9CmxV1+iAX5hn41tdws0V5b6YrSlHXI4UPyB4wdR2lXnhXYrr5/IGNpQ7AHYHCYY6+6DcOoE5OV+5SdehGYMOJgB+hI4iytnyUkQGsOMMNFkhkMe1hoFroHBy84MHQtMxwGk5bir24JOvgeQp+pTHKIA8qQVBvKjoNI3A+VTtUbhuAdir/bJjUrwO/Yn08fM143ZhciKaGXl+hW0wujBJI2W7y9vI/+1EPtOGoIiKV3dcPo7j+WdiqMUbRkSw19I9pvEnipTPj9rfrse1S78W3Sn5Ry2jKTUjtAraA+2Fdr2ZyQcVMDGb54LfCe2G9kF1qsn/BBgAYvXQdxeQxXMAAAAASUVORK5CYII="

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAfCAYAAAAIjIbwAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAK4SURBVEiJpZZNSBRhGMd/MztqvmWCERRu31oQmOXB7RIGu9rHQcili1EeikwQg25inqxLEBqE2CEITx7SxOhgTpIY6FBY0U0lMdwixEVLd/3anQ47a9PuzKxrfxiY9/k/z28eZt6PkXRdx0ohn6cE8APngEJgJ/ALmAD6gW6hamNWtVIiNOTzHAUeA+WWT/tXA0C9ULVxW2jI57kEdAI7NgGMaxG4JlTtRRI05PNUAj2AKw1gXBGgSqha3wY05PMUAGNAzhaAcf0GSoSqTcpG4NF/AjHq2wCkJW9pMfDJLtNVVo5S6UcS2wFYH3rDetczJ/gJGah2AmY138NVfAoAyb2PzBt1ZDa2OEGrZOCsnatU+gFYaX3Act1Vlmsuo4fDKN4KJ+h5BThi5673dROdniLyqhsAPTiLHpxDync7QQsVYJedGxkaIDI08Lfz6/XI+W4inz86QfMUYpM35WTPbGxB8Vagh8Os3m92Sl2SgW9OGVLebrIedqB4K4gGZli+fRM9OOtUMq0A74HjtsDWDuR8N9GJcVaa7qQCAnxQgF6gxsrNqG2IAQMzrHV1Ihed3PDM7zpBvdKSt1Qhtp0dTHSzX75Fys62rAz5PFbhr8Cx+Nr3A88TM1xl9rufTad+oWo95l2qA6i1paTWE6FqtwBkU7ABGNwicNCoB5I36VxgGChKA/gFOCNUbSEeMHeKYVwEJjcJnAQumIFJnZo6LgBGcVjCwBxwWqhaUgOyRTJG4hXA+qiNxautgLZQA9wPtNvY7ULVXtvV2kIN3QWCCbEg0ORU5AgVqjZP7Pwyqy3xw6QFNfQUiBr3UWPsqJRQoWoBYMQYjghV+542VJKkpAt4Z9jDNn5anWYAOT9X12YAfqysBoj9qG0DkmkpoFnAAeAQsHd0fjEIoC0szgF7gP3AYSDXqvgPhx3tbV4LqdkAAAAASUVORK5CYII="

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAfCAYAAAAIjIbwAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAALFSURBVEiJpdVPaBxlGMfxz0y2SU00kQ1FpWDbNakg1JoesooUhWxRiwTaBQ+KXq0gguBNi4daPIilopQKetGDIhqLB6E2qUgDbaLYivSisadW0ZjQ1OyaBLPjYXd13czMburvMu88f77v874vz/sGURSJU7mQ34UiHsIgenENP+IkPsG3cblBM7RcyG/HW9gTO9t/dQrP4odEaLmQ34f3cGMbwLoW8RQ+XQMtF/KjGEPHOoB1rWI/PvsHWi7kB1T356brANb1B3ZhJqwZ3vifQLX8oxCURoZ34kJSZMcDe2RGi4LuHpXfZ/019qHK+ek0+N0hHk8Ddh18RcfOIZC5734bX3tTkNueBt0f4sEkb2a0CJYPvWTpmSetfPB+1f7ovjTowxnckeRdOXxQuOMeq1+dEmQ3CbfmQPTbr2nQwaA0MhzfUg2qbwNE83P+fGxvWnjU8WJu8wvoTKdmiLC0JNyWE2zeYnXyy6ToUlAaGb6Iu1pVW9cNH30uyPYrF/JJIRdDfJ3k7Tx0RPf4VKvTbtY3IU4keaPZ6oF0vfxqdV9fPy7I9lv97nwa9ERQGhnOqF5nW5u9QXaTrsNHhIP/Vlq5ctny8wdE87NxwEu4s977RXycNHU4NCzo7RNdW2jVTUWMNd5Sx/F0WkYLvY0DEDYYn8Pp6wSeruVj7SXdhzPYsQ7g99iNhbqhsVLd41ML2IuZNoEzeKQRuKbShooHcA79KcA53BtXQLg2lu7xqRk8odqccYpUr8zYFcVCazqJYwm+Y/giKTF2+aj39s34CdkG1zxymvax3Urhqur71aijacB2oPAOKrVxBe+2SmgH+jPO1sZna//rgwZBIAiCZvNk7XumjSJk0pw9E9MbsPHS7qHLt3Ru8MvyypWByQu9WMFy0lOUtPyunonpLdiG285dXZyHqYXFOdyK25HrmZjui0v+G3Fk2TmKdNNYAAAAAElFTkSuQmCC"

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAfCAYAAAAIjIbwAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAJ2SURBVEiJpdZNaBR3HMbxz87GVTaaQkRUqPEtevBgiMLmJBWSYO1BTDypePJgC8GTHjQKQg5eFcUXaE/1ZqUXe1B3vVSwm1YRvCUirfhysAkmZKNZYtbDbkKyzuyO8YFh/jO/5/nOb97+M4lCZ0aEduAA9mALmjCOYdzBLTyGdDa/INgQAtuKy+gOqTVhZ2U5jXvow9B8U1AV6sGjCGCYuvFosqujJwq6DzexPCZwVstxc7KrY181tBU3kPxC4KySuDHZ1dE6H3oRKxYJnNUKXIBEoTPThif1EonmVVL9A0r/v1U8f7aWdXuAQ3HaSPUPSLa1C1o21LP2Bthdz9VwtE+yrT3OseH7AJtrOYL2jNTBI0rv38eFbgmwMqqaaF5l6alzoHjtUlxoc4CJqGqqf0CieaXp3F0f/7gVF1oI8CKskvyue+46Bi0bLLv6a7n7b9fNjSP0XwP+xrbqSml8zMzw0OeR+vonUejM7MfvcdzpbN7M8JAPPx2pZesJcBv/LqalED3H7QZM4wR+q5eYGjijND5Wy3Iync1PJ+ZN0tdw7Cu6vJ7O5n9k4dR3HPcXCbxfyauGFtGLp18IfIredDZfDIPCGH7As5jAZ9ibzuYXXOhqKLzEXozUAY5UfK+qC2HQ2Q4OoxRRLylPmaFnFAWl/Bm+ElG7grtRwVpQOIPRqn2j6K8Vqgd9p/z9mq8Lyjd00VD4GTOV8Qx+qReIA32Nh5Xxw8r2V0PhQWX9Zxxz2L/UnBpzg0uw7Pmu9perU0u8mSq+an3wpEn57ZsqdGZCH7nQThtzg0sbc4PrsRFr/3o3MQr5sYkRrEELNjXmBr8Jy38Cv/Kd6kVk1SsAAAAASUVORK5CYII="

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAfCAYAAAAIjIbwAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAK5SURBVEiJpZZNSBRhGMd/M44fDKmwi1AofborCBWK7HSJAlf6OAjpzagOHioQD10i9CZdgsog1KAg8lCH/CDqYE1CGOhUmBBeVvGUSYSL2n60pjsddlbG3XlnXfvDMPM+z/P/vQ/MO+87kmmaOCkW1OqBVuAM4APKgDVgDhgDhlTdmHbySpnQWFDzAw+BJsfZtusd0KHqRkgIjQW1C8AzYM8OgGlFgMuqboxkQWNBrRkYBgryAKa1CbSouvFqCxoLatXANFC6C2Bav4F6VTfmZSvw4D+BWP5eACnaGDgOzIgqlfYOlAZtW2zjw3s2XjwVWY7JQJvb9EqDhuzz59EwLQpw2q1C9vkx43H+XL+0U+hZBTgiBNYFADDDyxR23gRg4/UI5kJIZAHwKYBXCK2pTd0rq5ArqwAobG4hcf8Om2+GRDaPTGrxOspcWiQ5F2L9+SCxoEaipxuAoivtbp1GpWhjYBaodauyq6R/ENnnJxbURCWzMvBZlC261UNJ/yCSp2IrJnm9mPG427xfZGBUlDWjEWSfn6KuHgpONVF8dwDJ42VzxnFzSmtUijYGFFLb2cHMrOSpoPj2vW3rNDkXItF1AzP8ywm4ANSkv/1W4KVoarkugFRWjrm2SvLrJ7cuW1XdGLbvUgPAVTdHDj1SdeMagGwLdgLjuwSOW34ge5MuByaAo3kAvwEnVd1YTQfsnWIlzgPzOwTOA+fswKxObR1XA1O4fMLAMnBC1Y2sBmSHYqzCi4DzUZuKtzkBhVALPAb0CdJ9qm68FXmFUEvdQDgjFga63EyuUFU3VkidX3b1Zr6YvKCWHgNJ6zkJPMllyAlVdeMHMGkNJ61xflBJkrIu4KOVnhDk8+q0ECj9uf73O8BSYn2R1I9aCZBNywEtBg4Ah4B9UyuRMICxGlkG9gL7gcNAuZP5HzCZ4+9rEAAwAAAAAElFTkSuQmCC"

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAfCAYAAAAIjIbwAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAALISURBVEiJpdZPaBxlGMfxz0w2TXewFhIFRW00NhEEFXrIKiIVs8U/B8HmVkHpRXNQoQhezEHIwVOlBSlR9KAeRDBtED3UDgWpkk7VVvEitQhKoogkNDXZuKm76yGzss3uTJr6g4F5n+f5fd9neN95Z4JGo6GTKuXSLoziUQzielzCTziOqShOznbyBuuhlXJpCG9iT8fZrtQJvBDFyflMaKVcegrv47qrADa1hGeiODnWBq2US0/iKLo2AWyqhr1RnHzyH7RSLu3EWWy7BmBTf2FXFCcXwjRw+H8Cpf5DECyPDN+H77Iqg4Eh3fvHhDfcCC5/Oq322VQe/N4C9uUBtx5+W1Asqs/NCm+5Vc+BV1TJA+8N8XBWtnv/mKBYtPrhB/5+dlR1YhwUHsndbY8VcGdWNtzRr7GyonbsI12710CVcikPCIPB8shw51cKUZxorKyAoFgEjYV51ddfUz93JsvWCK1t3kwFxaL6+R9VJ8b9M/OVoLfPludezLMsF/Ar7s6qqM/Nqr48BmpfnBC+NyUcHMqD/hLi6zxg87FbO99A34SYzsrWvj0j6O3Tc3BS1+49eg5OCnr71L4/lwedDpZHhgvWjrPbO1VsmXhD4YEHr+i+emBMY+HPTuU/467muz+Kj7OmDgaGhLf1a1xazFt1GI3i5GjrKTWJ5/McG+itKE7GIGwJvoST1wg8mfrRfkhvxyncswngD3goipPFZqC1U2niCVy4SuAFPN4KbOu0peOdOI2+HOA87o/ipK2BsEOxtPBpZJ0LDezrBMyEpuDjOJKRPhLFyedZ3kxoqnEsrIst4NU8Uy40ipOL1r5frTq0fmE2BU31DurpfR3vbmTYEBrFyW+YSYcz6Xhz0CAI2i58maZPZeQ31Wk3tv2xenkWfq+uzln7UduKdtoG0B704w7cfPri0gIki0vzuAk7MIDtncz/AsP+88v+tvpRAAAAAElFTkSuQmCC"

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAfCAYAAAAIjIbwAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAJzSURBVEiJpdZNaBR3HMbxz45rDBsbIaFYsSrVJEdFhQQplYIRq1LB5CKVotCDCuLRQxUv3ouC+AJtL/VmFSmCWDdeFHS3rU2JUNAgVtQeSoIveWmi7njY2bAuM7sTfWDYmfk9z5dndnf+M5kwDMFEb48arUE/NqETrXiOe7iC87hdMefyhZlgtpaELpzAxphZK9ZG27e4iv24W20KakLb8UcCME4bI//2JOg2nMP8lMCK5uPcRG/PtsqJTBiGJnp7OpS/nw9mCazWC6zJ5QvDlabH3xMoyh+DzPiG7lUYjHM1n/opkfD/vq+TRiuz+Go2dYLOLuHkZD1LXxafp23TdPQ7QWeXqSMH60G/CLAiTcM5W/tl133q5S8XlP4s1rN2BmhPA23a9Y1wctKrsz82srYFGGvkyu7YLdPW7tXVy8LR/xrZxwM8bAjd/CWkaQn/BPitniPT9qFg8cdK9+6maQm/B7hYzxGsWw9e/30nDRAuBriEB4nQFR2g9NftJEu17uNS5d7vx89xrszyLsGSZUpDg2kuvz+XL1zIVC3Sp7EnTZ0EncnlC3t5e+k7gGvvCLwW5dVCp9GHoVkCh9CXyxem46DwDFswnBI4jM1Rbka1UHgUGUcaAEci3+PaQRy00mAnwoR5qLxkxl5REpTyY/hkwuwkfk0K1oPCYYzWnBvFoXqhRtCnys+vah1T88PMFgrfoxTtl/BDo0Aa6BPcjPZvRsfvDYUb0ef1NOa4d6kZtQwU56L5/merHy1smuvfqenHHTcGW5XvvqnxDd2xf7nYpi0DxXktA8Vl+ASLbj0dG4XCs7ERfISlWN4yUFwQl38Dowmv4+dm3nAAAAAASUVORK5CYII="

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAfCAYAAAAIjIbwAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAALaSURBVEiJpdbbaxx1GMbxz8xuTDO19sIbT7U1TRYVNaQXjQhFsSmeSrEN3lS0l1WQ4pUIVW/0D6go9YB6YQVBbCylCjVLbiq0o1IFBSEJRcUDIlmTmt2cd73Y2bpmdyZNfWBg5n3e9zsPzPx+M0GtVtNOlcGBbRjCA+jFNbiIcZzG8agYn283G6yEVgYHCngdu9re7b8awTNRMR5LhVYGB/bifVx9GcCGZvBkVIw/aYFWBgf2YBi5NQAbWsa+qBifvAStDA704Dw2XAGwob+xLSrGE2FSePV/AiXzRyAo79zeh2/TOnP37pLfMySI1qtVypZGRyx/ejwLflce+9PcoLug88VXQHV8TFi4VWdfv3mywPtC3Jfm5nfvBQsfHjP39BPmX3oOdOx+NCvpgyG2prm1chmEW7rryW/YVK9XylnQ3qC8c3v7JZVo3RvHhL2Ff280O2vuwGNqpT9Ts4TqL29b5R4ZEvYW1EqTFk8Oq46PCbq6dBw8lJWjnMfPuL2dm7+/vlLnnn9W7cKYRXR99JncPTuyoD+F+CrNDaL19ZOpvy7VarOzgq6uLOjXeZzAgXbu8g/fC3sLrjr8sqXREeHWHuGNN6mOj7Vrb+hEHqfwI7asdJc+eE/utjvk+vrl+vrrSUuTFt5+LQ14Aacaa38IH6d1Bt0F4abNahenVb/5MivlUFSMh5t3qTdxMGtiFb0VFeOnIGwqHsLoFQJHk3m0btIbcQZ3rgH4HXZExXi6UWhOKjEexsRlAifwUDOwJWlT4h6cw7UZwEncHRXjlgBhm2ZJ4+NI2xdq2N8OmApNwKdxNMU+GhXjz9NmU6GJXkBpRa2Ew1lDmdCoGE+pf7+adWTlg1kTNNE7qCbnVby72sCq0KgY/4azyeXZ5Hpt0CAIWg58kdhnUvw1Je3Ahj8WFn+B3+cXflX/UVuHVtoq0E5sxi24/tzUTAni6ZlJXIeb0Y2N7Yb/AWce9XA2v4q4AAAAAElFTkSuQmCC"

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAfCAYAAAAIjIbwAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAALOSURBVEiJpZZNSBRhGMd/M7uLOqVCH5D0bWoR1LYb7HYJA1f6OAjtXsREwUN5iIKu6aluUhiaGGSHOtQhTbyEOQlioVOhRbdVFvyoiHLRcldd150OMxubOzPr2h8G5n3+z/ObZ5j3YwRVVTFS1Od1AwHgLFAKFAC/gAmgH+iWZGXMqFZYD436vGVAO1Bp+LR/NQBclWQlaAqN+rwXgcfA1g0Ak1oE6iRZeZEGjfq8VUAPYMsCmNQa4Jdkpe8vNOrzlgBjQP4mgEn9BtySrEyKeuDefwLR61sBhEiFxwl8NMsUXR4ctQ0I0hYSP38Q73lGYvydFfy4CNRYAXNb2rA5XSBJ2E64yW1pQ3R5rKB+EThj5tr91QDEnj5huT7A8vXLqEtLOGobrKDnROCQaac7dgIQ72oHQA0FUWdnEMuOWEFLRWC7matGIwDYyrV1ILo8CHv2IuTlWUG32dEmr+Fkj/d1Y3O6yGm+TaK6biNAgIgITJu5a0MDrNxqYu3TuPaQgZeo4blM0Ck78B44auTayisRnW5i9++ihoIIxWU4qvwkJoJG6Ul9sAO9QL2RKxTtxlHlx3bSw+qjThwNjVrHQ6+toL1CpMJjR9vODhhl5Nzp1OaprvjIW2LNN8yAIeBwcu0HgOdmmaLLg1BQSGJmCjVk+eoBSVZ6UnepTuCKVUUGPZBkpRFATAleAwY3CRzU64H0TboQGAaOZQH8DJyWZGUhGUjtFN24AExuEDgJnE8FpnWa0nEJMIrFEgbmgFOSrKQ1IBokoydeAoyPWi1eYwQ0hergfqDDxO6QZOWVWa0pVFcTEF4XCwM3rYosoZKszKOdX6lqXf9hsoLqeggk9PsE0JWpICNUkpWvwIg+HNHH2UEFQUi7gDe6PWziZ9WpA8j/HludBfi2EvuC9qOWC6TTMkBzgP3AQaBodH4xDKAsLM4Bu4B9QDFQaFT8B/qR7a/oVIkwAAAAAElFTkSuQmCC"

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAfCAYAAAAIjIbwAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAALwSURBVEiJrZZvSBNxGMc/d9vUbTbBiOpFWZYjIrIpTCKiyEl/hIGOCuqF76oXJfQmIX2V7+qNYUhF9aoXQWUSvimnUGlrK0vwXYn4Z6sXtqGlQ9e868Xdxu28zZl9YezueZ7vZ8/dnt/vTpBlmZTinho0qgJ8wHGgAnAAv4BvwCvgOfBZa7D5gwCYWSkncAeoM8g5gGr1cx3oAy4DX7VFos7UAAxnARqpTq1vMITGPTVe4ClQnCcwpWLV500FBFmWiXtqdqPcnw1rBGr1G6iy+YNjqU5vrxOI6u8AEBZq3ZXAiL5CdLkpuHCFxP1OpC8hAEz1PszH6hBsdqSfMyS7n6RzGu03A+eMgIU3biJYrQiOEgV4pI7Cq9cAkCJhzAcPYTpQxWLTaeTYjNbeKAJHtRFLcwtFtzoRrNaMHzJ7fQAstbex2OTjz8tuBKsVU8NZfU8nRGBXBtTbSDIwRDIwlNm9cw9yLMrymz4Akr0vlCvYu08PrTADG7WR1KqyNLdkVApWK1J4On0ujyvzLtjsemipCMzro+vUgghM/WfopAh8zKdSioQRK5wIpZsAZbwApKkJfeknEejJB7o8rMxjQWs7pnofljPKJC6/f6sv7TEDvcAEsCMXNPn4EaZqN6ZKF6ZKlxILDKWnQdU40Jta+z7gmTYrlDsRt5UhjY5kDLfociM4SpCmJ9MToJHP5g92C6lNOu6puQtczHkPcuuezR+8BJn7aTMw8I/AAdVPBtTmDyaARmB0jcBR1ZdYAVU1B5wCxvIEjgEnVV9aeihAWC2MrgKMqnURfcIImurgPCBnycsoW6bhFWWDgvIY7sqS6wJeZzPmggK0ATFdLAa05jKtBp1FeX5p1YHuj1krFOABIKnHEvBwNUM+0O9AQD0OqOfrhgIMqt/v8ik2epdKy94fsgBF44dd4c0FFn4sJSK7B0ccKKtnaaHWbThyhp3a+0OF9v5QGbAT2Pphdj4GEJybjwJbgO1Aub0/VGLk/ws1/9op9EBEoQAAAABJRU5ErkJggg=="

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-board"
  }, [_c('div', {
    attrs: {
      "id": "search-input"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    ref: "input",
    attrs: {
      "type": "text",
      "id": "input-keyword",
      "placeholder": "请输入查询地址"
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchHandler($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.searchHandler
    }
  }, [_vm._v("查询")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "baidumapcontain"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "search-result"
    }
  }, [_c('ul', {
    staticClass: "poi-list"
  }, [_vm._l((_vm.resultData), function(item) {
    return [_c('li', {
      staticClass: "poi-item",
      on: {
        "click": function($event) {
          _vm.locate(item.point)
        }
      }
    }, [_c('span', [_c('div', {
      staticClass: "icon",
      style: ({
        backgroundPositionX: item.imgPosi + 'px'
      })
    }), _vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.address))])]), _vm._v(" "), _c('hr')]
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(65)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(68),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bmap_bmapLoader__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bmap_bmapLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__bmap_bmapLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__search_board__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__search_board___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__search_board__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Search',
    data: function data() {
        return {
            dashboard: __WEBPACK_IMPORTED_MODULE_1__search_board___default.a,
            arcgisClass: null
        };
    },

    props: {
        mapConfig: {
            map: {
                type: Object,
                required: true
            },
            esriLoader: {
                type: Object,
                required: true
            }
        }
    },
    watch: {
        mapConfig: function mapConfig(val, oldVal) {
            if (val.map != null && oldVal.map == null) {
                this.initEsriLoaders();
                this.$events.$emit('barItemBoardInited', this.$options.name, this.dashboard, this);
            }
        }
    },
    mounted: function mounted() {
        this.$events.$emit('barItemBoardInited', this.$options.name, this.dashboard, this);
    },
    methods: {
        initEsriLoaders: function initEsriLoaders() {
            var _this = this;

            this.mapConfig.esriLoader.dojoRequire(['esri/geometry/Point', 'esri/symbols/PictureMarkerSymbol', 'esri/graphic', 'esri/layers/GraphicsLayer'], function (Point, PictureMarkerSymbol, Graphic, GraphicsLayer) {
                _this.arcgisClass = { Point: Point, PictureMarkerSymbol: PictureMarkerSymbol, Graphic: Graphic, GraphicsLayer: GraphicsLayer };
            });
        },
        changeBoardState: function changeBoardState() {
            this.$events.$emit('barItemClick', { vmName: this.$options.name });
        }
    }
});

/***/ }),
/* 67 */
/***/ (function(module, exports) {

(function () {
  window.BMap_loadScriptTime = new Date().getTime();
  document.write('<script type="text/javascript" src="http://api.map.baidu.com/getscript?v=1.3&ak=&services=&t=20170328122103"></script>');
})();

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-container",
    on: {
      "click": _vm.changeBoardState
    }
  }, [_c('div', {
    staticClass: "icon"
  })])
},staticRenderFns: []}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(70)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ZoomIn',
  data: function data() {
    return {
      msg: 'zoonIn'
    };
  },

  props: {
    mapConfig: {
      map: {
        type: Object,
        required: true
      },
      esriLoader: {
        type: Object,
        required: true
      }
    }
  },
  methods: {
    zoomIn: function zoomIn() {
      this.mapConfig.map.setZoom(this.mapConfig.map.getZoom() + 1);
    }
  }
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zoomin-container",
    on: {
      "click": _vm.zoomIn
    }
  }, [_c('div', {
    staticClass: "icon"
  })])
},staticRenderFns: []}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(74)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(76),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ZoomOut',
  data: function data() {
    return {
      msg: 'zoonOut'
    };
  },

  props: {
    mapConfig: {
      map: {
        type: Object,
        required: true
      },
      esriLoader: {
        type: Object,
        required: true
      }
    }
  },
  methods: {
    zoomOut: function zoomOut() {
      this.mapConfig.map.setZoom(this.mapConfig.map.getZoom() - 1);
    }
  }
});

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zoomout-container",
    on: {
      "click": _vm.zoomOut
    }
  }, [_c('div', {
    staticClass: "icon"
  })])
},staticRenderFns: []}

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(78)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(80),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MapType',
  data: function data() {
    return {
      firstType: {
        class: 'normal',
        name: '矢量'
      },
      secondType: {
        class: 'earch',
        name: '地形'
      },
      thirdType: {
        class: 'terrain',
        name: '影像'
      },
      layers: {
        '矢量': {
          baseMapName: '矢量底图',
          baseLabelName: '矢量标注'
        },
        '地形': {
          baseMapName: '地形底图',
          baseLabelName: '地形标注'
        },
        '影像': {
          baseMapName: '影像底图',
          baseLabelName: '影像标注'
        }
      }
    };
  },

  props: {
    mapConfig: {
      map: {
        type: Object,
        required: true
      },
      esriLoader: {
        type: Object,
        required: true
      }
    }
  },
  methods: {
    changeMapType: function changeMapType(index) {
      if (!this.mapConfig.map.getLayer('baseMap')) return;
      var _self = this;

      var currentTypeName = null;
      var tempObj = null;
      switch (index) {
        case 0:
          return;
        case 1:
          currentTypeName = this.secondType.name;
          tempObj = this.firstType;
          this.firstType = this.secondType;
          this.secondType = tempObj;
          break;
        case 2:
          currentTypeName = this.thirdType.name;
          tempObj = this.firstType;
          this.firstType = this.thirdType;
          this.thirdType = tempObj;
          break;
        default:
          return;
      }
      var _layers$currentTypeNa = this.layers[currentTypeName],
          baseMapName = _layers$currentTypeNa.baseMapName,
          baseLabelName = _layers$currentTypeNa.baseLabelName;

      this.mapConfig.esriLoader.dojoRequire(['esri/map', 'esri/geometry/Extent', 'tdlib/TianDiTuLayer'], function (Map, Extent, TianDiTuLayer) {
        var baseMapLayer = new TianDiTuLayer(baseMapName, {
          id: 'baseMap'
        });
        var baseLabelLayer = new TianDiTuLayer(baseLabelName, {
          id: 'baseLabel'
        });
        _self.mapConfig.map.removeLayer(_self.mapConfig.map.getLayer('baseMap'));
        _self.mapConfig.map.removeLayer(_self.mapConfig.map.getLayer('baseLabel'));
        _self.mapConfig.map.addLayer(baseMapLayer, 0);
        _self.mapConfig.map.addLayer(baseLabelLayer, 1);
        _self.active = event.target.id;

        _self.$events.$emit('mapTypeChange', { baseMap: baseMapLayer, baseLabel: baseLabelLayer });
      });
    }
  }
});

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "maptype-container"
  }, [_c('ul', [_c('li', {
    staticClass: "mapTypeCard active",
    class: _vm.firstType.class,
    attrs: {
      "id": "normal"
    },
    on: {
      "click": function($event) {
        _vm.changeMapType(0)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.firstType.name))])]), _vm._v(" "), _c('li', {
    staticClass: "mapTypeCard",
    class: _vm.secondType.class,
    attrs: {
      "id": "earch"
    },
    on: {
      "click": function($event) {
        _vm.changeMapType(1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.secondType.name))])]), _vm._v(" "), _c('li', {
    staticClass: "mapTypeCard",
    class: _vm.thirdType.class,
    attrs: {
      "id": "terrain"
    },
    on: {
      "click": function($event) {
        _vm.changeMapType(2)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.thirdType.name))])])])])
},staticRenderFns: []}

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(82)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OverViewMap',
  data: function data() {
    return {
      isLoaderAdded: false,
      arcgisClass: null,
      flag: true };
  },

  props: {
    mapConfig: {
      default: null
    },

    elId: {
      type: String,
      default: 'overview',
      required: true
    }
  },
  watch: {
    mapConfig: function mapConfig(value) {
      if (value.map != null && !this.isLoaderAdded) {
        this.initEsriLoaders();
      }
    },
    arcgisClass: function arcgisClass(value) {
      if (value) {
        this.initOverViewMap();
      }
    },
    flag: function flag() {}
  },
  mounted: function mounted() {
    var _this = this;

    this.$events.$on('mapTypeChange', function () {
      _this.initOverViewMap();
    });
  },
  methods: {
    hiddenLegend: function hiddenLegend() {
      var pluArrow = document.getElementsByClassName('plugin-arrow-overview')[0];
      if (this.flag === false) {
        pluArrow = document.getElementsByClassName('top-arrow-overview')[0];
      }
      var overviewContainer = document.getElementsByClassName('overview-container')[0];
      var containerState = overviewContainer.style.display;
      var ele = pluArrow;
      if (containerState === 'none') {
        while (ele.className !== 'overview-wrapper') {
          ele = ele.parentElement;
        }
        ele.style.width = '300px';
        ele.style.height = '200px';
        overviewContainer.style.display = 'block';

        ele.style.backgroundColor = '';
        ele.style.boxShadow = '0 0 10px #666';
        this.flag = true;
      } else {
        while (ele.className !== 'overview-wrapper') {
          ele = ele.parentElement;
        }
        ele.style.width = '15px';
        ele.style.height = '15px';

        ele.style.boxShadow = '';
        overviewContainer.style.display = 'none';
        this.flag = false;
      }
    },
    initEsriLoaders: function initEsriLoaders() {
      var _this2 = this;

      this.mapConfig.esriLoader.dojoRequire(['tdlib/OverviewMap'], function (OverviewMap) {
        _this2.arcgisClass = { OverviewMap: OverviewMap };
        _this2.isLoaderAdded = true;
      });
    },
    initOverViewMap: function initOverViewMap() {
      if (this.mapConfig.map.overviewMapDijit) {
        this.mapConfig.map.overviewMapDijit.destroy();
        this.mapConfig.map.overviewMapDijit = null;
      }
      if (this.$refs.overviewContainer.children.length === 0) {
        var overViewEl = window.document.createElement('div');
        overViewEl.id = this.elId;
        overViewEl.className = 'overview-box';
        this.$refs.overviewContainer.appendChild(overViewEl);
      }
      this.$nextTick(function () {
        this.mapConfig.map.overviewMapDijit = new this.arcgisClass.OverviewMap({
          map: this.mapConfig.map,
          visible: true
        }, this.elId);
        this.mapConfig.map.overviewMapDijit.startup();
        this.isLoaderAdded = true;
      });
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-box"
  }, [_c('div', {
    staticClass: "plugin-arrow-overview",
    class: [_vm.flag ? 'plugin-arrow-overview' : 'top-arrow-overview'],
    on: {
      "click": _vm.hiddenLegend
    }
  }), _vm._v(" "), _c('div', {
    ref: "overviewContainer",
    staticClass: "overview-container"
  })])
},staticRenderFns: []}

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// static/js/app.js